export default "__VITE_ASSET__CGZi8SRw__"